import { useMediaQuery, Box, Typography } from '@mui/material'
import GoBackButton from 'components/GoBackButton/GoBackButton'
import { ResponsiveBoxWrapper } from 'components/Layout/Layout.styled'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import { SaveBtn } from 'components/SaveBtn/SaveBtn'
import { FormikState, Formik, Form } from 'formik'
import { useGetDtsPlace, usePatchDtsPlace } from 'hooks/usePlaces'
import theme from 'lib/theme'
import { useAlert } from 'providers/AlertProvider'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import Input from 'components/Input/Input'
import { PlaceSecondarySidebar } from './PlaceSecondarySidebar'

export const PlacePayment = () => {
  const { t } = useTranslation()
  const { setAlert } = useAlert()
  const { placeId } = useParams()

  const { isLoading, error, dtsPlace } = useGetDtsPlace(placeId as string)
  const { mutateAsync, isLoading: isLoadingRequest } = usePatchDtsPlace(
    placeId as string
  )

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [showOverlay, setShowOverlay] = useState(true)

  const handleSubmit = async (
    values: { paymentProjectCode: string },
    resetForm: (
      nextState?: Partial<FormikState<{ paymentProjectCode: string }>>
    ) => void
  ) => {
    const placeValues = {
      payment_project_code: values.paymentProjectCode,
      store_guid: dtsPlace.guid,
    }
    await mutateAsync(placeValues, {
      onSuccess: () => {
        setAlert(t('saved'), 'success', {
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        })
        resetForm({ values })
      },
      onError: () => {
        setAlert(t('failureMessage'), 'failure', {
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        })
      },
    })
  }

  const initialValues = {
    paymentProjectCode: dtsPlace?.paymentProjectCode ?? '',
  }

  if (isLoading) return <LoadingIndicator />
  if (error) return <h1>Error</h1>
  return (
    <Box sx={{ display: 'flex' }}>
      <PlaceSecondarySidebar
        placeId={placeId as string}
        placeName={dtsPlace.name}
        placeMasterId={placeId ?? ''}
      />
      <ResponsiveBoxWrapper showOverlay={showOverlay}>
        <Box
          maxWidth='500px'
          height='100%'
          display='flex'
          flexDirection='column'>
          {isMobile && <GoBackButton onClick={() => setShowOverlay(false)} />}
          <Typography variant='body2' mt={8} ml={1}>
            {t('payments')}
          </Typography>
          <Formik
            initialValues={initialValues}
            onSubmit={async (values, { resetForm }) =>
              handleSubmit(values, resetForm)
            }>
            {({ isValid, dirty }) => (
              <Form>
                <Box p={2} mt={2}>
                  <Input
                    marginBottom={theme.spacing(4)}
                    label={t('paymentProjectCode')}
                    name='paymentProjectCode'
                    type='text'
                    variant='filled'
                    fullWidth
                  />
                </Box>
                <Box
                  sx={{
                    position: 'fixed',
                    bottom: isMobile ? '0px' : theme.spacing(2),
                    width: isMobile ? '92%' : '500px',
                    zIndex: 1000,
                  }}>
                  <SaveBtn
                    showOverlay={showOverlay}
                    dirty={dirty}
                    isValid={isValid}
                    isLoadingRequest={isLoadingRequest}
                  />
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </ResponsiveBoxWrapper>
    </Box>
  )
}
